/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function(){
  var interval = setInterval(function(){
    if($('.product-list').length) {
      $('.product-list').each(function(){  
        var highestBox = 0;
        $('.product-item__title', this).each(function(){
          if($(this).height() > highestBox) {
            highestBox = $(this).height(); 
          }
        });  
        $('.product-item__title',this).height(highestBox);

        var highestBox1 = 0;
        $('.current_variant_SKU', this).each(function(){
          if($(this).height() > highestBox1) {
            highestBox1 = $(this).height(); 
          }
        });  
        $('.current_variant_SKU',this).height(highestBox1);

        var highestBox2 = 0;
        $('.product-item__vendor', this).each(function(){
          if($(this).height() > highestBox2) {
            highestBox2 = $(this).height(); 
          }
        });  
        $('.product-item__vendor',this).height(highestBox2);

      }); 
      clearInterval(interval);
    }
  }, 300);

  var interval2 = setInterval(function(){
    if($('[data-section-type="recently-viewed-products"] .product-list').length) {
      $('[data-section-type="recently-viewed-products"] .product-list').each(function(){  
        var highestBox = 0;
        $('.product-item__title', this).each(function(){
          if($(this).height() > highestBox) {
            highestBox = $(this).height(); 
          }
        });  
        $('.product-item__title',this).height(highestBox);

        var highestBox1 = 0;
        $('.current_variant_SKU', this).each(function(){
          if($(this).height() > highestBox1) {
            highestBox1 = $(this).height(); 
          }
        });  
        $('.current_variant_SKU',this).height(highestBox1);

        var highestBox2 = 0;
        $('.product-item__vendor', this).each(function(){
          if($(this).height() > highestBox2) {
            highestBox2 = $(this).height(); 
          }
        });  
        $('.product-item__vendor',this).height(highestBox2);

      }); 
      clearInterval(interval2);
    }
  }, 300);


});